var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 282,
    viewBox: "0 0 517 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9203 170C95.9203 170 60.7803 110 131.78 146C202.78 182 177.27 121 118.03 91C58.7903 61 126.98 17 266.88 62C406.78 107 601.79 84 474.79 1",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.04 205.07C119.31 199.54 122.47 182.21 99.0304 164.09C74.9204 145.46 59.4404 153.63 55.3404 158.93C51.2404 164.24 8.45039 219.6 4.52039 224.69C0.590385 229.78 -7.18961 254.01 15.5904 271.61C39.6904 290.24 59.6104 277.73 64.2204 271.76C68.8404 265.79 110.77 210.6 115.04 205.07Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8305 184.99C79.2205 184.63 80.8605 184.8 82.1605 185.81C83.4605 186.82 84.0405 188.36 84.0405 189.8C84.0405 191.26 83.5405 192.7 82.5805 193.95L76.1605 202.26C75.2005 203.5 73.9205 204.35 72.5205 204.71C71.1305 205.07 69.4806 204.9 68.1906 203.9C66.8906 202.9 66.3105 201.36 66.3105 199.91C66.3105 198.46 66.8106 197.01 67.7606 195.77L74.1805 187.46C75.1405 186.22 76.4205 185.37 77.8305 185.01V184.99ZM70.6405 199.87C70.6605 200.27 70.7705 200.4 70.8405 200.46C70.9205 200.52 71.0705 200.59 71.4605 200.51C71.8405 200.41 72.3405 200.12 72.7305 199.6L79.1505 191.29C79.5505 190.78 79.7106 190.21 79.7006 189.83C79.6906 189.42 79.5705 189.3 79.5005 189.24C79.4305 189.18 79.2706 189.11 78.8806 189.19C78.5106 189.29 78.0005 189.58 77.6105 190.09L71.1906 198.4C70.7906 198.91 70.6305 199.47 70.6405 199.86V199.87Z",
    fill: "#989897"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6204 269.13C44.7404 290.86 62.2204 271.36 62.9504 270.52L95.9204 227.65C78.4404 241.8 45.2904 261.97 17.3504 240.38C12.8904 236.93 8.68044 232.49 4.82043 227.18C1.78043 233.23 -5.20959 252.27 16.6104 269.13H16.6204Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.98790d29fee14b05f8338b5a2612ba8e.svg";
export { ForwardRef as ReactComponent };